"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("@emotion/styled"));
exports.default = styled_1.default.div `
  position: absolute;
  right: 6px;
  display: flex;
  align-items: center;
  height: 28px;
  padding: 0 12px;
  border-radius: 6px;
  background-color: var(--surface-bg);
  color: var(--gray-30);
  line-height: 20px;
  font-size: 14px;
`;
